import { Controller } from "@hotwired/stimulus"

// Controller for collapsible/expandable sections
export default class extends Controller {
  static targets = ["content", "icon"]
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    this.updateVisibility()
  }

  toggle(event) {
    // Don't toggle if clicking on a form element inside
    if (event.target.closest('form')) return

    this.openValue = !this.openValue
    this.updateVisibility()
  }

  open() {
    this.openValue = true
    this.updateVisibility()
  }

  close() {
    this.openValue = false
    this.updateVisibility()
  }

  updateVisibility() {
    if (this.hasContentTarget) {
      if (this.openValue) {
        this.contentTarget.classList.remove('hidden')
      } else {
        this.contentTarget.classList.add('hidden')
      }
    }

    if (this.hasIconTarget) {
      if (this.openValue) {
        this.iconTarget.classList.add('rotate-180')
      } else {
        this.iconTarget.classList.remove('rotate-180')
      }
    }
  }
}
